/**
 * Positioning directions for the listbox when a select is open.
 * @public
 */
export var SelectPosition;
(function (SelectPosition) {
    SelectPosition["above"] = "above";
    SelectPosition["below"] = "below";
})(SelectPosition || (SelectPosition = {}));
